import React from 'react'
import { motion } from 'framer-motion';
import lubrification from '../Assets/lubification.png'; // Correction : "vabiratoire" → "Vibratoire"
import lubrification1 from '../Assets/lubrification2.PNG'; // Correction : nom cohérent
import './Gestionlubrification.css'; // Correction : "Analysevibiratiore" → "AnalyseVibratoire"


const Gestionlubrification = () => {
  const imageVariants = {
    hidden: { opacity: 0, x: 50 },
    visible: (index) => ({
      opacity: 1,
      x: 0,
      transition: {
        duration: 0.6,
        delay: index * 0.3,
        ease: 'easeOut',
      },
    }),
  };

  const textVariants = {
    hidden: { opacity: 0, x: -50 },
    visible: (index) => ({
      opacity: 1,
      x: 0,
      transition: {
        duration: 0.6,
        delay: index * 0.3,
        ease: 'easeOut',
      },
    }),
  };
  return (
    <div className="solution-page-container">
      <div className="solution-header">
        <h1>Gestion lubrification</h1>
      </div>
      <div className="solution-content">
        {[
          {
            image: lubrification,
            alt: 'lubrification',
            description:
              'Une lubrification maîtrisée est essentielle pour garantir la fiabilité et la longévité des équipements industriels. Nos solutions de gestion de la lubrification permettent d’optimiser les intervalles de graissage, de choisir les bons produits et de prévenir les défaillances liées au manque ou à l’excès de lubrifiant.',
          },
          {
            image: lubrification1,
            alt: 'lubrification1',
            description:
              'Grâce à des plans de lubrification adaptés, des outils de suivi et des audits réguliers, nous aidons les industriels à réduire les arrêts machines et à améliorer la performance globale de leur maintenance.',
          },
        ].map((block, index) => (
          <div key={index} className="solution-block">
            <motion.div
              className="solution-block-image-container"
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true, amount: 0.3 }}
              variants={imageVariants}
              custom={index}
            >
              <img src={block.image} alt={block.alt} className="solution-block-image" />
            </motion.div>
            <motion.div
              className="solution-block-text-container"
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true, amount: 0.3 }}
              variants={textVariants}
              custom={index}
            >
              <p className="solution-block-description">{block.description}</p>
            </motion.div>
          </div>
        ))}
      </div>
    </div>
  );
};

    
      
      
    
  

export default Gestionlubrification
